import { render, staticRenderFns } from "./AnnouncementsCreateDialog.vue?vue&type=template&id=2b744100&scoped=true&"
import script from "./AnnouncementsCreateDialog.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsCreateDialog.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsCreateDialog.vue?vue&type=style&index=0&id=2b744100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b744100",
  null
  
)

export default component.exports